// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data: image/svg+xml,%3Csvg width=%2710%27 height=%279%27 viewBox=%270 0 10 9%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L3.5 7.5L9 1%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .radio-button,
app-root .checkbox-button {
  position: relative;
  display: inline-block;
  color: #595959;
}
app-root .radio-button label,
app-root .checkbox-button label {
  z-index: 1;
  background-color: white;
  font-weight: 600;
  padding: 8px;
  padding-left: calc(8px + 1.3em);
  border: 1px solid #595959;
  border-radius: 4px;
  will-change: border-color, colour, transform;
  transition-property: border-color, colour, transform;
  transition-duration: 0.15s;
  transition-timing-function: ease-in;
}
app-root .radio-button label:hover,
app-root .checkbox-button label:hover {
  transition-duration: 0.075s;
  color: #262626;
  border-color: #262626;
}
app-root .radio-button input[type='radio'],
app-root .checkbox-button input[type='radio'],
app-root .radio-button input[type='checkbox'],
app-root .checkbox-button input[type='checkbox'] {
  -webkit-appearance: none;
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--background-grey);
  margin: 0;
  position: relative;
  top: 50%;
  width: 1em;
  height: 1em;
  font: inherit;
  color: currentColor;
  border: 0.0625em solid currentColor;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  left: 8px;
  transform: translateY(-50%);
  transform-origin: 5em;
  will-change: outline;
  transition: outline 0.2s ease-in-out, transform 0.1s ease-in, left 0.1s ease-in;
}
app-root .radio-button input[type='radio']::before,
app-root .checkbox-button input[type='radio']::before,
app-root .radio-button input[type='checkbox']::before,
app-root .checkbox-button input[type='checkbox']::before {
  will-change: transform;
  position: relative;
  display: block;
  z-index: 3;
  border-radius: 50%;
  transform: scale(0);
  transition: transform 0.15s ease-in-out;
  box-shadow: inset 1em 1em var(--selection-grey);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}
app-root .radio-button input[type='radio']:active,
app-root .checkbox-button input[type='radio']:active,
app-root .radio-button input[type='checkbox']:active,
app-root .checkbox-button input[type='checkbox']:active {
  transform: translateY(-50%) scale(0.95);
}
app-root .radio-button input[type='radio']:active + label,
app-root .checkbox-button input[type='radio']:active + label,
app-root .radio-button input[type='checkbox']:active + label,
app-root .checkbox-button input[type='checkbox']:active + label {
  transform: scale(0.95);
}
app-root .radio-button input[type='radio']:focus,
app-root .checkbox-button input[type='radio']:focus,
app-root .radio-button input[type='checkbox']:focus,
app-root .checkbox-button input[type='checkbox']:focus {
  outline: 0;
}
app-root .radio-button input[type='radio']:focus + label,
app-root .checkbox-button input[type='radio']:focus + label,
app-root .radio-button input[type='checkbox']:focus + label,
app-root .checkbox-button input[type='checkbox']:focus + label {
  outline: #6c6c6c solid 2px;
}
app-root .radio-button input[type='radio']:checked,
app-root .checkbox-button input[type='radio']:checked,
app-root .radio-button input[type='checkbox']:checked,
app-root .checkbox-button input[type='checkbox']:checked {
  color: var(--selection-grey);
}
app-root .radio-button input[type='radio']:checked + label,
app-root .checkbox-button input[type='radio']:checked + label,
app-root .radio-button input[type='checkbox']:checked + label,
app-root .checkbox-button input[type='checkbox']:checked + label {
  color: #262626;
  background-color: #f0f0f0;
  border-color: #262626;
}
app-root .radio-button input[type='radio']:checked + label::after,
app-root .checkbox-button input[type='radio']:checked + label::after,
app-root .radio-button input[type='checkbox']:checked + label::after,
app-root .checkbox-button input[type='checkbox']:checked + label::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border: 2px #262626 solid;
  border-radius: 3px;
}
app-root .radio-button input[type='radio']:hover + label,
app-root .checkbox-button input[type='radio']:hover + label,
app-root .radio-button input[type='checkbox']:hover + label,
app-root .checkbox-button input[type='checkbox']:hover + label {
  border-color: #3e3e3e;
  box-shadow: 0 0 0 2px #dddddd;
}
app-root .radio-button input[type='checkbox']::before,
app-root .checkbox-button input[type='checkbox']::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  width: 1em;
  height: 1em;
  line-height: 0.95em;
  text-align: center;
  top: -0.0625em;
  left: -0.0625em;
  transform: scale(0) rotate(-30deg);
  transition-duration: 0.1s;
}
app-root .radio-button input[type='checkbox']:checked::before,
app-root .checkbox-button input[type='checkbox']:checked::before {
  transform: scale(1);
}
app-root .radio-button input[type='radio']::before,
app-root .checkbox-button input[type='radio']::before {
  content: '';
  width: 0.5em;
  height: 0.5em;
  top: 0.1875em;
  left: 0.1875em;
}
app-root .radio-button input[type='radio']:checked::before,
app-root .checkbox-button input[type='radio']:checked::before {
  transform: scale(1);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Inputs/Generic/Multi/MultiButton.less","webpack://./src/Components/Form/Inputs/Generic/Multi/Utilities/baseStyle.less"],"names":[],"mappings":"AAGA;;EAGI,kBAAA;EACA,qBAAA;EACA,cAAA;AAHJ;AAFA;;EAQM,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,oDAAA;EACA,0BAAA;EACA,mCAAA;AAHN;AAIM;;EACE,2BAAA;EACA,cAAA;EACA,qBAAA;AADR;AAtBA;;;;ECDE,wBAAA;EACA,gBAAA;ED6BA,iBAAiB;EC3BjB,wCAAA;EACA,SAAA;EAEA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EDiBI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;EACA,+EAAA;AAWN;AChCE;;;;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,+CAAA;EDqCF,+BAA+B;EClC7B,4BAAA;ADoCJ;AAzBM;;;;EACE,uCAAA;AA8BR;AA/BM;;;;EAII,sBAAA;AAiCV;AA7BM;;;;EACE,UAAA;AAkCR;AAnCM;;;;EAII,0BAAA;AAqCV;AAjCM;;;;EACE,4BAAA;AAsCR;AAvCM;;;;EAII,cAAA;EACA,yBAAA;EACA,qBAAA;AAyCV;AAxCU;;;;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;AA6CZ;AAxCM;;;;EACE,qBAAA;EACA,6BAAA;AA6CR;ACzFE;;EACE,gDAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;EACA,yBAAA;AD4FJ;ACzFE;;EACE,mBAAA;AD4FJ;ACvFE;;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;AD0FJ;ACvFE;;EACE,mBAAA;AD0FJ","sourcesContent":["@import './Utilities/baseStyle.less';\n@import '../../../../../Styles/colours.less';\n\napp-root {\n  .radio-button,\n  .checkbox-button {\n    position: relative;\n    display: inline-block;\n    color: @border-grey;\n\n    label {\n      z-index: 1;\n      background-color: white;\n      font-weight: 600;\n      padding: 8px;\n      padding-left: calc(8px + 1.3em);\n      border: 1px solid @border-grey;\n      border-radius: 4px;\n\n      will-change: border-color, colour, transform;\n      transition-property: border-color, colour, transform;\n      transition-duration: 0.15s;\n      transition-timing-function: ease-in;\n      &:hover {\n        transition-duration: 0.075s;\n        color: @selection-grey;\n        border-color: @selection-grey;\n      }\n    }\n\n    input[type='radio'],\n    input[type='checkbox'] {\n      .shared-multi-input-styles();\n      position: absolute;\n      z-index: 2;\n      left: 8px;\n      transform: translateY(-50%);\n      transform-origin: 5em; // only affects scale\n      will-change: outline;\n      transition: outline 0.2s ease-in-out, transform 0.1s ease-in, left 0.1s ease-in;\n      &:active {\n        transform: translateY(-50%) scale(0.95);\n\n        + label {\n          transform: scale(0.95);\n        }\n      }\n\n      &:focus {\n        outline: 0;\n\n        + label {\n          outline: @outline-grey solid 2px;\n        }\n      }\n\n      &:checked {\n        color: var(--selection-grey);\n\n        + label {\n          color: @selection-grey;\n          background-color: @input-background-grey;\n          border-color: @selection-grey;\n          &::after {\n            content: '';\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            top: 0;\n            left: 0;\n            border: 2px @selection-grey solid;\n            border-radius: 3px;\n          }\n        }\n      }\n\n      &:hover + label {\n        border-color: @hover-grey;\n        box-shadow: 0 0 0 2px @outline-hover-grey;\n      }\n    }\n\n    input[type='checkbox'] {\n      .checkbox-input-styles();\n    }\n    input[type='radio'] {\n      .radio-input-styles();\n    }\n  }\n}\n",".shared-multi-input-styles() {\n  // Resets\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 */\n  background-color: var(--background-grey);\n  margin: 0;\n\n  position: relative;\n  top: 50%;\n  width: 1em;\n  height: 1em;\n\n  font: inherit;\n  color: currentColor;\n  border: 0.0625em solid currentColor;\n  border-radius: 50%;\n\n  &::before {\n    will-change: transform;\n    position: relative;\n    display: block;\n    z-index: 3;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: transform 0.15s ease-in-out;\n    box-shadow: inset 1em 1em var(--selection-grey);\n\n    /* Windows High Contrast Mode */\n    background-color: CanvasText;\n  }\n}\n\n.checkbox-input-styles() {\n  &::before {\n    content: url(\"data: image/svg+xml,%3Csvg width='10' height='9' viewBox='0 0 10 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L3.5 7.5L9 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E\");\n    color: white;\n    width: 1em;\n    height: 1em;\n    line-height: 0.95em;\n    text-align: center;\n    top: -0.0625em;\n    left: -0.0625em;\n    transform: scale(0) rotate(-30deg);\n    transition-duration: 0.1s;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n\n.radio-input-styles() {\n  &::before {\n    content: '';\n    width: 0.5em;\n    height: 0.5em;\n    top: 0.1875em;\n    left: 0.1875em;\n  }\n\n  &:checked::before {\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
